import React from 'react';
import './Tag.css';

const colorClassNames = {
    regular: '',
    primary: 'Tag--primary',
    red: 'Tag--red',
    green: 'Tag--green',
};

export default function Tag({ children, color }) {
    const className = `Tag ${colorClassNames[color]}`;

    return <span className={className}>{children}</span>;
}
